module.exports = __webpack_public_path__ + "img/P4.18ac2074.jpg";